// ─── GLOW STICKERS / MILESTONES ───────────────────────────────────────────────
// Earned based on how many glows a user's jar has collected.
// Displayed on public profile and inbox header.

export const STICKERS = [
  { id: 'first_light',  threshold: 1,   emoji: '🕯',  en: 'First Light',   ar: 'أول ضو',      enSub: 'Received your first glow',      arSub: 'استلمت أول ضو' },
  { id: 'warm_start',   threshold: 5,   emoji: '🌅',  en: 'Warm Start',    ar: 'بداية دافية', enSub: '5 glows collected',             arSub: '٥ أضواء اتجمعت' },
  { id: 'golden_jar',   threshold: 10,  emoji: '✨',  en: 'Golden Jar',    ar: 'جرّة ذهبية',  enSub: '10 glows — your jar is shining', arSub: '١٠ أضواء — جرّتك بتلمع' },
  { id: 'full_heart',   threshold: 25,  emoji: '💛',  en: 'Full Heart',    ar: 'قلب مليان',   enSub: '25 glows — truly loved',        arSub: '٢٥ ضو — محبوب فعلاً' },
  { id: 'glow_keeper',  threshold: 50,  emoji: '🌟',  en: 'Glow Keeper',   ar: 'حارس الأضواء', enSub: '50 glows collected',           arSub: '٥٠ ضو اتجمعت' },
  { id: 'radiant',      threshold: 100, emoji: '☀️', en: 'Radiant',       ar: 'مضيء',        enSub: 'Full jar — 100 glows!',         arSub: 'جرّة ممتلية — ١٠٠ ضو!' },
];

/**
 * Returns the highest earned sticker for a given glow count.
 */
export function getEarnedSticker(count) {
  if (!count || count < 1) return null;
  const earned = STICKERS.filter(s => count >= s.threshold);
  return earned.length > 0 ? earned[earned.length - 1] : null;
}

/**
 * Returns all stickers earned for a given glow count.
 */
export function getAllEarnedStickers(count) {
  return STICKERS.filter(s => count >= s.threshold);
}

/**
 * Returns the next sticker milestone not yet earned.
 */
export function getNextSticker(count) {
  return STICKERS.find(s => count < s.threshold) || null;
}

/**
 * Check if a new sticker was just earned (between prevCount and newCount).
 * Used to show a celebration toast.
 */
export function checkNewSticker(prevCount, newCount) {
  const prev = getEarnedSticker(prevCount);
  const next = getEarnedSticker(newCount);
  if (!prev && next) return next;
  if (prev && next && prev.id !== next.id) return next;
  return null;
}
